import React, { useEffect, useState } from "react";

function AdvertWidget(props) {
  const { title, zoneid } = props;

  //console.log(zoneid);
  return (
    <>
      {zoneid !== undefined && (
        <iframe
          id="a5f1f9b0"
          name="a5f1f9b0"
          data-src={`https://revive.boringmoney.co.uk/www/delivery/afr.php?zoneid=${zoneid}&cb=12345`}
          frameborder="0"
          scrolling="no"
          width="970"
          height="250"
          allow="autoplay"
          name={`${zoneid}`}
          data-cookiefirst-category="advertising"
          data-revive-type="true"
        >
          <a
            href="https://revive.boringmoney.co.uk/www/delivery/ck.php?n=aeaf1089&cb=12345"
            target="_blank"
          >
            <img
              src={`https://revive.boringmoney.co.uk/www/delivery/avw.php?zoneid=${zoneid}&amp;cb=12345&n=aeaf1089"`}
              border="0"
              alt=""
            />
          </a>
        </iframe>
      )}
    </>
  );
}

export default AdvertWidget;
